import Wix from '../services/wix-sdk-polyfill';

export const navigateToSitePage = pageId => () => Wix.navigateToPage(pageId);



// WEBPACK FOOTER //
// ./app/actions/navigate-to-site-page.js